import logo1 from 'images/logos/lifepro-prime1.png'
// import logo2 from 'images/logos/accidentpro-prime1.png'
import logo3 from 'images/logos/disability-prime1.png'
import logo4 from 'images/logos/criticalillnesspro-prime1.png'
import { CardItem } from 'types'

export const baseStoreItems: CardItem[] = [
  {
    id: 'ITEM_0',
    title: 'Life Cover',
    subtitle: `
      <p>
        Helps take care of your family financially in the event of your death or
        diagnosis of a terminal illness, allowing them to make mortgage repayments,
        debt payments, cover children's education and household costs.
      </p>
      <h4>This plan includes:</h4>
      <h4><em>Life Cover</em></h4>
      <ul>
        <li>
          Examples of life events: Death due to an accident or sickness e.g., motor
          vehicle accident or heart attack. Terminal illness e.g., cancer
        </li>
        <li>
          Lump sum benefit amount of $500K in the event you pass away or are diagnosed
          with a terminal illness
        </li>
        <li>
          Advance payment of $15,000 to cover immediate costs, such as funeral
          expenses
        </li>
      </ul>`,
    price: 15,
    priceString: '$15 per month',
    pricePeriod: 'month',
    currency: 'USD',
    features: [
      // ...
    ],
    basketOptions: {
      postPriceText: `<em>For this you receive the following cover:</em><br>Life insurance amount: $500,000`,
    },
    headerImage: logo1,
  },
  {
    id: 'ITEM_1',
    title: 'Life Plus Total and Permanent Disability Cover',
    subtitle: `
      <p>
        In addition to all the benefits of our Life Cover, you also receive Total and
        Permanent Disability (TPD) cover. TPD cover helps support your family and
        lifestyle in the event you cannot work due to an injury or sickness.
      </p>
      <h4>This plan includes:</h4>
      <h4><em>TPD Cover</em></h4>
      <ul>
        <li>
          Examples of TPD events: Injury from an accident, severe depression, loss of
          hearing
        </li>
        <li>
          Lump sum benefit of up to $375K if you are absent from work for at least 6
          months due to an injury or sickness, and your medical practitioner confirms
          that you are totally and permanently disabled
        </li>
      </ul>
      <h4><em>Life Cover</em></h4>
      <ul>
        <li>
          Lump sum benefit amount of $500K in the event you pass away or are diagnosed
          with a terminal illness
        </li>
        <li>
          Advance payment of $15,000 to cover immediate costs, such as funeral
          expenses
        </li>
      </ul>`,
    price: 35,
    priceString: '$35 per month',
    pricePeriod: 'month',
    currency: 'USD',
    features: [
      // ...
    ],
    basketOptions: {
      postPriceText: `<em>For this you receive the following cover:</em><br>Life insurance amount: $500,000<br>TPD insurance amount: $375,000`,
    },
    headerImage: logo3,
  },
  {
    id: 'ITEM_2',
    title: 'Life Plus Trauma Cover',
    subtitle: `
      <p>
        In addition to all the benefits of our Life Cover, you also receive Trauma
        cover. Trauma cover helps to protect the financial health of you and your
        family in the event you suffer a trauma event such as Cancer or Heart attack.
      </p>
      <h4>This plan includes:</h4>
      <h4><em>Trauma Cover</em></h4>
      <ul>
        <li>Examples of Trauma events: Cancer, heart attack, Stroke</li>
        <li>
          Lump sum payment of $100k in the event you suffer one of the listed trauma
          events
        </li>
      </ul>
      <h4><em>Life Cover</em></h4>
      <ul>
        <li>
          Lump sum benefit amount of $500K in the event you pass away or are diagnosed
          with a terminal illness
        </li>
        <li>
          Advance payment of $15,000 to cover immediate costs, such as funeral
          expenses
        </li>
      </ul>`,
    price: 35,
    priceString: '$35 per month',
    pricePeriod: 'month',
    currency: 'USD',
    features: [
      // ...
    ],
    basketOptions: {
      postPriceText: `<em>For this you receive the following cover:</em><br>Life insurance amount: $500,000<br>Trauma insurance amount: $100,000`,
    },
    headerImage: logo4,
  },
]
